// constants.js
// const API_URL = "http://13.233.197.233:3001";
const API_URL = "https://api.priyeshgupta.com"; 
// const API_URL = "http://localhost:3001"; 

export default API_URL;
